export default {
  textTransform: "uppercase",
  color: "#777",
  fontSize: "11px",
  fontWeight: "300",
  paddingLeft: "15px",
  paddingRight: "15px"
};
